import { Button } from "@opero/ui";

interface FailedModulesNoticeProps {
  failed: Array<{ slug: string; error: string }>;
  isRetrying: boolean;
  onRetry: () => void;
  onContinue: () => void;
}

export function FailedModulesNotice({
  failed,
  isRetrying,
  onRetry,
  onContinue,
}: FailedModulesNoticeProps) {
  return (
    <div className="mb-6 rounded-2xl border border-amber-300 bg-amber-50 p-6 dark:border-amber-800 dark:bg-amber-900/20">
      <h3 className="text-base font-semibold text-amber-900 dark:text-amber-200">
        Some modules didn't install
      </h3>
      <p className="mt-1 text-sm text-amber-800 dark:text-amber-300">
        Your workspace is ready, but the modules below need attention. Retry
        is safe — provisioning is idempotent.
      </p>
      <ul className="mt-4 space-y-2 text-sm">
        {failed.map((f) => (
          <li
            key={f.slug}
            className="rounded-lg bg-white/60 p-3 text-amber-900 dark:bg-slate-900/40 dark:text-amber-200"
          >
            <span className="font-mono text-xs">{f.slug}</span>
            <p className="mt-1 text-xs text-amber-700 dark:text-amber-300">
              {f.error}
            </p>
          </li>
        ))}
      </ul>
      <div className="mt-5 flex gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={onContinue}
          disabled={isRetrying}
        >
          Continue anyway
        </Button>
        <Button type="button" onClick={onRetry} disabled={isRetrying}>
          {isRetrying ? "Retrying…" : "Retry failed modules"}
        </Button>
      </div>
    </div>
  );
}
